export type {
  BrokenLink,
  LinkCheckResult,
  WikiLink,
} from "./types.js";
export { extractWikiLinks } from "./extract.js";
export {
  buildFileIndex,
  resolveLink,
  toRel,
} from "./resolve.js";
export type {
  BuildIndexOptions,
  FileIndex,
  ResolveOpts,
  ResolveOutcome,
} from "./resolve.js";
export { checkDirectory, topBrokenTargets } from "./checker.js";
export type { CheckDirectoryOptions } from "./checker.js";
export { rewriteBody, rewriteDirectory } from "./rewrite.js";
export type {
  FileRewrite,
  RedirectionMap,
  RewriteOptions,
  RewriteResult,
} from "./rewrite.js";
